var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show-data-list"},_vm._l((_vm.properties),function(property,index){return _c('show-data-list-row',_vm._b({key:index,staticClass:"row",attrs:{"redText":property.redText}},'show-data-list-row',property,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }